import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';

import { ApiError, apiClient, storePath } from '@/lib/api-client';
import type { StorePlatform, StoreScreenshot, UpsertScreenshotBody } from '@/types/store';

import { storeKeys } from './store-keys';

export interface UpsertScreenshotVars {
  platform: StorePlatform;
  locale: string;
  body: UpsertScreenshotBody;
}

/** PUT …/screenshots/:platform/:locale — save (or overwrite) one draft slot. */
export function useUpsertScreenshot(): UseMutationResult<
  StoreScreenshot,
  ApiError,
  UpsertScreenshotVars
> {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ platform, locale, body }) =>
      apiClient.put<StoreScreenshot>(
        storePath(`/screenshots/${platform}/${encodeURIComponent(locale)}`),
        body,
      ),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: storeKeys.all });
    },
  });
}
